const SPECIAL_CHARS_REGEX_GLOBAL = /[$+,:;@#|'<>.^*()\s\t!]/g;

/**
 * Use to replace potential malicious code characters to prevent possible
 * XSS attacks.
 * @param str The URL string to modify.
 * @returns {string} The sanitized URL string.
 */
export const sanitizeUrl = (str: string) =>
  str.replace(SPECIAL_CHARS_REGEX_GLOBAL, '');
